import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TooltipDirective } from '../../../../shared/components/ui/tooltip/tooltip.directive';
import { FaDuotoneIconComponent } from '@fortawesome/angular-fontawesome';
import { faTriangleExclamation, faXmark } from '@fortawesome/pro-duotone-svg-icons';
import { TranslatePipe } from '@ngx-translate/core';

export interface ConfirmDialogData {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  /** Render the confirm action in a destructive (red) style. */
  danger?: boolean;
}

/**
 * Generic confirmation modal. Resolves to `true` when the user confirms and
 * `false` (or `undefined` on backdrop dismiss) otherwise. Built on the same
 * `MatDialog` pattern as `RoomDialog`; callers open it with the
 * `confirm-dialog` panel/backdrop classes (see `material-overrides.scss`) and
 * pass a {@link ConfirmDialogData} payload.
 */
@Component({
  selector: 'andor-confirm-dialog',
  standalone: true,
  imports: [TranslatePipe, TooltipDirective, FaDuotoneIconComponent],
  templateUrl: './confirm-dialog.html',
  styleUrl: './confirm-dialog.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialog {
  private readonly _dialogRef = inject<MatDialogRef<ConfirmDialog, boolean>>(MatDialogRef);
  protected readonly data = inject<ConfirmDialogData>(MAT_DIALOG_DATA);

  protected readonly faTriangleExclamation = faTriangleExclamation;
  protected readonly faXmark = faXmark;

  protected confirm(): void {
    this._dialogRef.close(true);
  }

  protected cancel(): void {
    this._dialogRef.close(false);
  }
}
